// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Time left`
};

const de_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Verbleibende Zeit`
};

const es_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Tiempo restante`
};

const fr_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Temps restant`
};

const fi_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Aikaa jäljellä`
};

const ja_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `残り時間`
};

const nl_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Resterende tijd`
};

const pt_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Tempo restante`
};

const ro_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Timp rămas`
};

const th_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `เวลาที่เหลือ`
};

const ur_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `باقی وقت`
};

const zh_hant1_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `剩餘時間`
};

const da_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Tid tilbage`
};

const it_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Tempo rimanente`
};

const vn_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Thời gian còn lại`
};

const ko_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `남은 시간`
};

const tr_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Kalan süre`
};

const lv_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Atlikušais laiks`
};

const ar_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `الوقت المتبقي`
};

const bs_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Preostalo vrijeme`
};

const sl_widget_stats_time_left = /** @type {(inputs: {}) => string} */ () => {
	return `Preostali čas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_stats_time_left = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_stats_time_left(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_stats_time_left", locale)
	if (locale === "en") return en_widget_stats_time_left(inputs)
	if (locale === "de") return de_widget_stats_time_left(inputs)
	if (locale === "es") return es_widget_stats_time_left(inputs)
	if (locale === "fr") return fr_widget_stats_time_left(inputs)
	if (locale === "fi") return fi_widget_stats_time_left(inputs)
	if (locale === "ja") return ja_widget_stats_time_left(inputs)
	if (locale === "nl") return nl_widget_stats_time_left(inputs)
	if (locale === "pt") return pt_widget_stats_time_left(inputs)
	if (locale === "ro") return ro_widget_stats_time_left(inputs)
	if (locale === "th") return th_widget_stats_time_left(inputs)
	if (locale === "ur") return ur_widget_stats_time_left(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_stats_time_left(inputs)
	if (locale === "da") return da_widget_stats_time_left(inputs)
	if (locale === "it") return it_widget_stats_time_left(inputs)
	if (locale === "vn") return vn_widget_stats_time_left(inputs)
	if (locale === "ko") return ko_widget_stats_time_left(inputs)
	if (locale === "tr") return tr_widget_stats_time_left(inputs)
	if (locale === "lv") return lv_widget_stats_time_left(inputs)
	if (locale === "ar") return ar_widget_stats_time_left(inputs)
	if (locale === "bs") return bs_widget_stats_time_left(inputs)
	if (locale === "sl") return sl_widget_stats_time_left(inputs)
	return "widget_stats_time_left"
};